import React from 'react'
import PropTypes from 'prop-types'

import { Typeof } from 'utils';

class ExternalLink extends React.Component {

  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(event) {

    //Stop event propagation
    event.stopPropagation();

    let onClick = this.props.onClick;

    if(Typeof.func(onClick)) {
      onClick();
    }
  }

  render() {

    const { target, newTab, children} = this.props;

    return (
      <a href={target} onClick={this.handleClick} target={newTab ? '_blank' : undefined}>
        {children}
      </a>
    );
  }
}

ExternalLink.propTypes = {
  target: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  newTab: PropTypes.bool.isRequired
};

ExternalLink.defaultProps = {
  newTab: false
};

export default ExternalLink;
